/**
 * Created by ray on 2017/11/17.
 */
import { Component, ViewContainerRef, OnInit } from '@angular/core';

@Component({
  templateUrl: './error.component.html'
})
export class ErrorComponent {
}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/error/error.component.ts